import React, {RefObject} from 'react';
import {Toast, ToastMessage} from "primereact/toast";
import {AxiosError} from "axios";

type ToastSeverityType = 'success' | 'info' | 'warn' | 'error';

class NotificationPopUp {
    static toast: RefObject<Toast> = React.createRef<Toast>();

    public static handleGenericError = (errorObject: any, summary?: string) => {
        console.error(errorObject);
        let errorTitle = summary || "Error";

        let detail: any = "Unspecified error";
        if (errorObject instanceof AxiosError) {
            let response = errorObject.response?.data

            if (response != null && response.message != null) {
                detail = this.formatErrorString(response.message as string);
            }
        } else if (typeof errorObject.message === "string") {
            detail = this.formatErrorString(errorObject.message);
        } else if (typeof errorObject === "string") {
            detail = this.formatErrorString(errorObject);
        }

        NotificationPopUp.showToast({
            severity: "error",
            summary: errorTitle,
            detail: detail,
            life: 30000
        })
    }

    private static formatErrorString(message: string) {
        return <>
            {
                message.split("\n").map((line: string, index: number) => {
                    return <><span>{line}</span><br/></>
                })
            }
        </>;
    }

    public static show = (details: any, status?: ToastSeverityType, title?: string) => {
        let s: ToastSeverityType;
        let t;

        if (status === undefined) {
            s = 'info';
        } else {
            s = status;
        }

        if (!title) {
            t = ""
        } else {
            t = title;
        }

        NotificationPopUp.toast.current?.show({severity: s, summary: t, detail: details});
    }

    public static showToast = (showArgs: ToastMessage) => {
        let args = {...showArgs}
        if (args.severity === undefined) {
            args.severity = 'info';
        }
        if (!args.summary) {
            args.summary = "";
        }

        NotificationPopUp.toast.current?.show(args);
    }

    public static showMultiple = (notificationArray: Array<any>, status?: ToastSeverityType) => {
        //DEFAULTS
        if (!status) {
            status = 'info';
        }

        let arr:Array<any> = notificationArray.map(obj => {
            return {
                severity: status,
                detail: obj
            }
        })
      console.log(arr)

    }

    public static showHTML = (c: any, status?: ToastSeverityType) => {
        let s: ToastSeverityType;

        if (status === undefined) {
            s = 'info';
        } else {
            s = status;
        }

        NotificationPopUp.toast.current?.show({severity: s, detail: <pre>{c}</pre>});
    }
}

export default NotificationPopUp;